import React from "react";
import { Outlet } from "react-router-dom";

const UserRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default UserRoot;
